import MarketingLayout from "@/components/MarketingLayout";
import WaitlistNew from "@/pages/newsite/WaitlistNew";

export default function WaitlistPage({ variant }) {
  return (
    <MarketingLayout footer="legal">
      <WaitlistNew platform={variant} />
    </MarketingLayout>
  );
}
